module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_hokkaido-39f692c569ef930a79f8089e40cf1474.jpg";